import { change, FieldArray } from 'redux-form';
import React, { useState } from 'react';
import { FieldInput } from 'src/components/redux-form/fields/FieldInput';
import { FieldTextArea } from '../../../../../components/redux-form/fields/FieldTextArea';
import { FieldDropdown } from '../../../../../components/redux-form/fields/FieldDropdown';
import RenderStepsArray from './RenderStepsArray';
import RenderPhasesArray from './RenderPhasesArray';
import RenderPromptsArray from './RenderPromptsArray';
import GeneralEnumService from '../../../../../enumerables/general-enum';
import { getValFromEnum } from '../../../../../components/redux-form/utils/dropdown-values';
import classNames from 'classnames';
import styles from './assets/program-array-fields.module.scss';
import { SelectList } from 'react-widgets';
import { email, maxLength, required, Validators } from '../../../../../components/redux-form/utils/validators';
import { useDispatch } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMinusCircle, faPlusCircle, faRedo } from '@fortawesome/free-solid-svg-icons';

export interface PBTargetFormData {
    id: string | number;
    title: string;
    typeDropDown: SelectObject | undefined;
    phaseTitle: string;
    phaseStartDate: any;
}

interface PBTargetFormProps {
    memberD: any;
    idTarget: any;
    remove: any;
    showAttempts: boolean;
    showOption: boolean;
    isMastered: boolean;
    isPhased: boolean;
    rowType: any;
    showPrompt: boolean;
    fields: any;
    isCollapsed?: boolean;
}

const validators: Validators<PBTargetFormData> = {
    typeDropDown: [required({ message: 'Type is required.' }), maxLength({ max: 255 })],
    title: [required({ message: 'Title is required.' }), maxLength({ max: 255 })],
    phaseTitle: [required({ message: 'Phase title is required.' }), maxLength({ max: 255 })],
    phaseStartDate: [required({ message: 'Phase start date is required.' }), maxLength({ max: 255 })],
};

const PBTargetForm: React.FunctionComponent<PBTargetFormProps> = ({
    fields,
    memberD,
    showOption,
    isMastered,
    isPhased,
    idTarget,
    rowType,
    showPrompt,
    showAttempts,
    isCollapsed,
}: PBTargetFormProps) => {
    const GeneralEnum = GeneralEnumService ? GeneralEnumService.getEnum('ProgramType') : {};
    const typeItems: SelectObject[] = getValFromEnum(GeneralEnum);

    const MasteryDirectionEnum = GeneralEnumService ? GeneralEnumService.getEnum('MasteryDirection') : {};
    const masteryDirectionItems: SelectObject[] = getValFromEnum(MasteryDirectionEnum);

    const EnumSet = GeneralEnumService ? GeneralEnumService.getEnum('ProgramPrompt') : {};
    const programPromptItems: SelectObject[] = getValFromEnum(EnumSet);

    const promptItems: SelectObject[] = getValFromEnum(EnumSet);

    const [isPromts, setIsPromts] = useState(showPrompt ? true : false);

    const [isShowPhased, setIsShowPhased] = useState(idTarget ? false : true);
    const [isShowPhasedFields, setIsShowPhasedFields] = useState(false);

    const dispatch = useDispatch();

    const handleChange = (event: any) => {
        if (event.target.checked) {
            setIsPromts(true);
        } else {
            setIsPromts(false);
        }
    };

    const handlePhasedChange = (event: boolean) => {
        setIsShowPhased(false);
        dispatch(change('program-book', `${memberD}.isPhased`, event ? 1 : 0));
        setIsShowPhasedFields(event);
    };

    let typeLabel = '';
    if (rowType == 1) {
        typeLabel = ', %';
    } else if (rowType == 2) {
        typeLabel = ', secs';
    } else if (rowType == 3) {
        typeLabel = ', %';
    } else if (rowType == 4) {
        typeLabel = ', times';
    }

    let isMasteredLabel = '';
    if (isMastered) {
        isMasteredLabel = ' (mastered)';
    }

    return (
        <div style={{ display: 'inline-block', width: '85%', verticalAlign: 'top', paddingBottom: '20px' }}>
            <div className={classNames(styles.wrappedFields, styles.wrappedBaseline)}>
                <FieldInput
                    name={`${memberD}.id`}
                    type="hidden"
                    wrapperConfig={{
                        classes: {
                            inputWrapper: 'm-0',
                        },
                    }}
                />
                <FieldInput
                    name={`${memberD}.title`}
                    type="text"
                    validate={validators.title}
                    wrapperConfig={{
                        label: 'Target' + isMasteredLabel + ' *: ',
                        classes: {
                            inputWrapper:
                                'mr-3 w-50 mb-0 ' +
                                (isMasteredLabel ? classNames(styles.masteryMark) : '') +
                                ' ' +
                                classNames(styles.wFullWidth, styles.titleWidth),
                        },
                    }}
                />
                <FieldDropdown
                    name={`${memberD}.type`}
                    data={typeItems}
                    //onChange={() => memberD.push({})}
                    textField={'label'}
                    valueField={'value'}
                    validate={validators.typeDropDown}
                    wrapperConfig={{
                        label: 'Type *:',
                        classes: { inputWrapper: 'mr-3 w-33 mb-0 ' + classNames(styles.wFullWidth) },
                    }}
                />
                <FieldTextArea
                    name={`${memberD}.description`}
                    wrapperConfig={{
                        label: 'Description:',
                        classes: { inputWrapper: 'mr-3 w-100 mb-0 ' },
                    }}
                />
            </div>

            {!isCollapsed && (
                <>
                    {isShowPhased ? (
                        <div>
                            <div>Need phases for the target?</div>
                            <div className={classNames(styles.phasesButtons)}>
                                <button
                                    type="button"
                                    className={classNames('btn', 'btn-outline-info', ' mt-2 ', styles.addBtn)}
                                    title="Yes"
                                    onClick={() => handlePhasedChange(true)}
                                >
                                    <FontAwesomeIcon icon={faPlusCircle} />
                                    <span>Yes, please</span>
                                </button>
                                <button
                                    type="button"
                                    className={classNames('btn btn-outline-info mt-2', styles.addBtn, styles.fixBtn)}
                                    title="No"
                                    onClick={() => handlePhasedChange(false)}
                                >
                                    <FontAwesomeIcon icon={faMinusCircle} />
                                    <span>No, thanks</span>
                                </button>
                                <FieldInput
                                    name={`${memberD}.isPhased`}
                                    type="hidden"
                                    wrapperConfig={{
                                        classes: {
                                            inputWrapper: 'm-0',
                                        },
                                    }}
                                />
                            </div>
                        </div>
                    ) : null}

                    {isShowPhased ? null : isPhased || isShowPhasedFields ? (
                        <div className={classNames(styles.wrappedFields, styles.wrappedBaseline)}>
                            <FieldArray
                                showAttempts={showAttempts}
                                showPrompt={showPrompt}
                                promptItems={promptItems}
                                masteryDirectionItems={masteryDirectionItems}
                                showOption={showOption}
                                isPromts={isPromts}
                                typeLabel={typeLabel}
                                validators={validators}
                                handleChange={handleChange}
                                name={`${memberD}.programTargetPhases`}
                                component={RenderPhasesArray}
                            />
                        </div>
                    ) : (
                        <div>
                            <div className={classNames(styles.wrappedFields, styles.wrappedBaseline)}>
                                {showAttempts ? (
                                    <FieldInput
                                        name={`${memberD}.minAttempts`}
                                        type="number"
                                        wrapperConfig={{
                                            label: 'Attempts:',
                                            classes: { inputWrapper: 'mr-3 w-50 ' + classNames(styles.wFullWidth) },
                                        }}
                                    />
                                ) : null}
                                {showPrompt ? (
                                    <FieldDropdown
                                        name={`${memberD}.prompt`}
                                        data={promptItems}
                                        textField={'label'}
                                        valueField={'value'}
                                        wrapperConfig={{
                                            label: 'Prompt:',
                                            classes: { inputWrapper: 'mr-3 w-33 mb-0 ' + classNames(styles.wFullWidth) },
                                        }}
                                    />
                                ) : null}

                                <FieldInput
                                    name={`${memberD}.masterValue`}
                                    type="number"
                                    wrapperConfig={{
                                        label: 'Mastery' + typeLabel + ' *:',
                                        classes: { inputWrapper: 'mr-3 w-33 ' + classNames(styles.wFullWidth) },
                                    }}
                                />
                                <FieldDropdown
                                    name={`${memberD}.masteryDirection`}
                                    data={masteryDirectionItems}
                                    textField={'label'}
                                    valueField={'value'}
                                    wrapperConfig={{
                                        label: 'Mastery direction *:',
                                        classes: { inputWrapper: 'mr-3 w-33 mb-0 ' + classNames(styles.wFullWidth) },
                                    }}
                                />
                                <FieldInput
                                    name={`${memberD}.masterNumberOfSeance`}
                                    type="number"
                                    wrapperConfig={{
                                        label: 'During sessions *:',
                                        classes: { inputWrapper: 'mr-3 w-33 ' + classNames(styles.wFullWidth) },
                                    }}
                                />
                            </div>

                            {showOption ? (
                                <FieldArray name={`${memberD}.programTargetOptions`} component={RenderStepsArray} />
                            ) : null}

                            <div className={classNames(styles.hidden)}>
                                <ul
                                    className={classNames(styles.ul, styles.targetWrap, styles.propsNeedWrap)}
                                    style={{ paddingBottom: 0 }}
                                >
                                    <li>
                                        <FieldInput
                                            name={`${memberD}.hasPrompts`}
                                            type="checkbox"
                                            onChange={handleChange}
                                            wrapperConfig={{
                                                label: 'Need prompts?',
                                                classes: {
                                                    inputWrapper: 'customCheckbox',
                                                },
                                            }}
                                        />
                                    </li>
                                </ul>
                                {isPromts ? (
                                    <FieldArray name={`${memberD}.programTargetPrompts`} component={RenderPromptsArray} />
                                ) : null}
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};
export default React.memo(PBTargetForm);
